import styled from "styled-components";

export const ResponsiveContainer = styled.div`
  max-width: 640px;
  width: 100%;
  margin: ${({ theme }) => theme.spacings.m} auto;
`;

export const Grid = styled.div`
  grid-column: content-start / content-end;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: ${({ theme }) => theme.spacings.xs} ${({ theme }) => theme.spacings.xs1};
  grid-auto-rows: auto;
  align-items: start;
  align-content: start;
  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-column: 1 / -1;
    grid-template-columns: repeat(12, 1fr);
  }
`;

export const GridItem = styled.div<{ $selected?: boolean }>`
  grid-column: span 4;
  padding: ${({ theme }) => theme.spacings.s};
  cursor: pointer;
  user-select: none;

  border-radius: ${({ theme }) => theme.borders.radius.m};
  border: 1px solid ${({ theme }) => theme.colors.neutral[90]};

  ${({ theme, $selected }) =>
    $selected &&
    `
    background-color: ${theme.colors.secondary[99]};
    border-color: ${theme.colors.secondary[70]};
  `}

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary[99]};
    border-color: ${({ theme }) => theme.colors.secondary[99]};
  }
`;
